import { useController } from "react-hook-form";

import FormField, { useFormField } from "./FormField/FormField";
import { Select } from "src/designsystem/Select/Select";
import { SelectProps } from "antd";
import { UseFormFieldProps } from "./Form.types";
import { ForwardedRef, forwardRef } from "react";
import { RefSelectProps } from "antd/lib/select";

export interface FormSelectProps
  extends
    UseFormFieldProps,
    Omit<SelectProps, "onSelect" | "onDeselect" | "filterOption" | "filterSort"> {
  name: string;
}

export const FormSelect = forwardRef(
  (props: FormSelectProps, ref: ForwardedRef<RefSelectProps>) => {
    const { formFieldProps, childProps } = useFormField(props);
    const { field } = useController({ name: childProps.name });
    /**
     * antd's select component has this weird issue that when value is not present it should be explicitly passed as undefined
     * and only then you get to see the placeholder, this PR fixes that issue
     * StackOverflow post here: https://stackoverflow.com/questions/45546300/antd-design-select-placeholder-issues
     */
    return (
      <FormField {...formFieldProps}>
        <Select {...childProps} {...field} value={field.value || undefined} ref={ref} />
      </FormField>
    );
  }
);
